import { render, staticRenderFns } from "./objinput.vue?vue&type=template&id=185a078a&scoped=true"
import script from "./objinput.vue?vue&type=script&lang=js"
export * from "./objinput.vue?vue&type=script&lang=js"
import style0 from "./objinput.vue?vue&type=style&index=0&id=185a078a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a078a",
  null
  
)

export default component.exports